import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { colors } from '~/theme';
import { DicaMockupId } from './dicas.content';

const WHATSAPP_HEADER = '#075E54';
const WHATSAPP_BACKGROUND = '#ECE5DD';

const UrlsMockup = () => (
  <Box
    component="img"
    src="/dicas/tip-urls-70f1fb.png"
    alt=""
    sx={{ width: '100%', display: 'block', borderRadius: '8px', border: `1px solid ${colors.gray}` }}
  />
);

const EmailHeaderMockup = () => (
  <Stack
    direction="row"
    spacing={1.5}
    alignItems="center"
    p={1.5}
    borderRadius={2}
    sx={{ backgroundColor: colors.lightGray }}
  >
    <Avatar sx={{ width: 32, height: 32, backgroundColor: colors.blue, fontSize: 14 }}>C</Avatar>
    <Stack spacing={0}>
      <Typography variant="caption" fontWeight={700} sx={{ color: colors.charcoal }}>
        CUB &lt;naoresponda@cub.com.br&gt;
      </Typography>
      <Typography variant="caption" sx={{ color: colors.darkGray }}>
        para mim
      </Typography>
    </Stack>
  </Stack>
);

const WhatsAppMockup = ({ message }: { message: string }) => (
  <Stack borderRadius={2} overflow="hidden" sx={{ border: `1px solid ${colors.gray}` }}>
    <Stack direction="row" alignItems="center" spacing={1} px={1.5} py={1} sx={{ backgroundColor: WHATSAPP_HEADER }}>
      <ArrowBackIosNewRoundedIcon sx={{ fontSize: 14, color: colors.white }} />
      <Avatar sx={{ width: 24, height: 24, fontSize: 12 }}>G</Avatar>
      <Typography variant="caption" fontWeight={700} sx={{ color: colors.white, flexGrow: 1 }}>
        Golpista
      </Typography>
      <VideocamRoundedIcon sx={{ fontSize: 16, color: colors.white }} />
      <CallRoundedIcon sx={{ fontSize: 14, color: colors.white }} />
    </Stack>
    <Box p={1.5} sx={{ backgroundColor: WHATSAPP_BACKGROUND }}>
      <Box display="inline-block" px={1.5} py={1} borderRadius={2} sx={{ backgroundColor: colors.white, maxWidth: '100%' }}>
        <Typography variant="caption" sx={{ color: colors.charcoal, wordBreak: 'break-word' }}>
          {message}
        </Typography>
      </Box>
    </Box>
  </Stack>
);

const PaymentDownloadMockup = () => (
  <Box
    display="inline-flex"
    alignItems="center"
    gap={1}
    px={2}
    py={1}
    borderRadius={1}
    sx={{ backgroundColor: colors.error.main, color: colors.white }}
  >
    <Typography variant="caption" fontWeight={700}>
      BAIXAR BOLETO
    </Typography>
    <DownloadRoundedIcon sx={{ fontSize: 16 }} />
  </Box>
);

const ClientAreaMockup = () => (
  <Stack spacing={1} p={1.5} borderRadius={2} sx={{ backgroundColor: colors.lightGray }}>
    <Typography variant="caption" fontWeight={700} textAlign="center" sx={{ color: colors.charcoal }}>
      Escolha como receber seu acesso
    </Typography>
    <Typography variant="caption" textAlign="center" sx={{ color: colors.darkGray }}>
      Selecione abaixo um de seus canais de contato para receber o acesso a sua área do cliente
    </Typography>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      px={1.5}
      py={1}
      borderRadius={2}
      sx={{ backgroundColor: colors.white }}
    >
      <Typography variant="caption" sx={{ color: colors.charcoal }}>
        (11) 96***-**74
      </Typography>
      <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 16, color: colors.darkGray }} />
    </Stack>
  </Stack>
);

export const DICA_MOCKUPS: Record<DicaMockupId, JSX.Element> = {
  urls: <UrlsMockup />,
  email: <EmailHeaderMockup />,
  linksSuspeitos: (
    <WhatsAppMockup message="Link do pagamento: https://cubpay.online/?id=8d6c04a22401da1ec405a18a729e2" />
  ),
  dadosSensiveis: <WhatsAppMockup message="Preciso que me envie o token" />,
  pagamentos: <PaymentDownloadMockup />,
  areaCliente: <ClientAreaMockup />,
};
